/* eslint-disable import/order */
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";

import { muiTheme } from "constants/muiTheme";
import theme from "constants/theme";

import { GlobalStyles } from "globalStyles";
import "lib/logRocket/initialize";
import "lib/sentry/initialize";
import React from "react";

import { Router } from "react-router-dom";
import "react-table-hoc-fixed-columns/lib/styles.css";
import "react-table/react-table.css";
import "react-toastify/dist/ReactToastify.css";

import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";
import "typeface-roboto";
import history from "../appHistory";
import "components/PageShell/animations.css";
import Root from "containers/Root";
import { Store } from "redux";
import { Root as RootType } from "react-dom/client";

export function persistCallback(root: RootType, getStore: () => Store) {
  root.render(
    <StyledComponentsThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={muiTheme}>
          <GlobalStyles />
          <Router history={history}>
            <Root store={getStore()} />
          </Router>
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </StyledComponentsThemeProvider>,
  );
}
